<template>
  <v-container :fill-height="fillHeight" :fluid="fluid">
    <v-layout>
      <v-flex>
        <!-- The top row with the tab and a slot to add more content -->
        <v-layout v-if="title" justify-space-between>
          <v-flex shrink class="subheading white--text font-weight-light" :style="titleStyle">
            <div :class="{ 'pt-2': bigTitle }">{{ title }}</div>
          </v-flex>
          <!-- Slot to add more items using v-flex components -->
          <slot name="top" />
        </v-layout>
        <!-- The content of the container -->
        <v-layout :fill-height="fillHeight" :style="containerStyle" wrap>
          <slot />
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    /* Add a padding vertical to the title to show it more big and fit the space if
    you add buttons in the top slot */
    bigTitle: {
      type: Boolean,
      default: false
    },
    centeredTitle: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "#607D8B"
    },
    fillHeight: {
      type: Boolean,
      default: false
    },
    fluid: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    titleMarginLeft: {
      type: String,
      default: "30px"
    }
  },
  computed: {
    containerStyle() {
      return {
        border: `solid 1px ${this.color}`,
        borderRadius: "10px",
        padding: "10px"
      };
    },
    titleStyle() {
      return {
        marginLeft: this.titleMarginLeft,
        padding: "5px 10px",
        borderRadius: "5px 5px 0 0",
        backgroundColor: this.color
      };
    }
  }
};
</script>